import React from 'react';
import {Modal} from '@/components/common-components';
import {Button, Spin, Typography} from 'antd';
import {antdNotification} from '@/utils/notification';
import {observer} from 'mobx-react-lite';
import {PAGES_API} from '@/api/content-optimizer';
import {getLocalesByKey as t} from '@/utils/translation';
// Types
import type {DeleteDialogInstance} from '@/store/content-optimizer/pages';

// Stylesheets
import {useRouter} from 'next/router';
import styles from './style.module.scss';
import {useStore} from '@/store/root-store';
import {routes} from '@/utils/const';
import {useState} from 'react';
import {LoadingOutlined} from '@ant-design/icons';

interface Props {
  data: DeleteDialogInstance;
  removeFromEditorCallback?: (value: boolean) => void;
}

const DeleteModal: React.FC<Props> = observer(({data, removeFromEditorCallback}) => {
  const {isOpen, uuid, closeDialog, removeItem} = data;
  const {Title} = Typography;
  const router = useRouter();

  const {contentOptimizer: {pages: {loadPages, loadPagesSummary, getAllProjects, activeProjectId}}} = useStore('');
  const [deletingArticle, setDeletingArticle] = useState(false);

  const antIcon = <LoadingOutlined style={{fontSize: 14, color: '#7f4ead', marginRight: '10px'}} spin />;

  const onDelete = async () => {
    setDeletingArticle(true);
    try {
      const resp = await PAGES_API.deletePage(uuid);
      removeItem();
      loadPages(false, activeProjectId);
      loadPagesSummary();
      getAllProjects();
      closeDialog();
      if (removeFromEditorCallback) {
        removeFromEditorCallback(true);
      }
      router.push(`/${routes.landingPageOptimizer}`, null, {shallow: true});
      antdNotification.success(t('successfully-deleted-page'));
      return resp;
    } catch (e) {
      router.push(`/${routes.landingPageOptimizer}`, null, {shallow: true});
      return Promise.reject(e);
    } finally {
      setDeletingArticle(false);
    }
  };
  return (
    <Modal style={{position: 'absolute', top: '250px', right: '35%'}} visible={isOpen} closable={false}>
      <div className={styles.deleteModalContent}>
        <Title className={styles.deleteModalTitle} level={4}>{t('delete-article?')}</Title>
        <div className={styles.deleteModalSubtitle}>{t('deleting-article-permanently')}</div>
      </div>
      <div className={styles.deleteModalFooter}>
        <Button onClick={closeDialog} className={styles.deleteModalButton}>
          {t('cancel')}
        </Button>
        <Button
          onClick={onDelete}
          type='primary'
          danger
          style={deletingArticle ? {pointerEvents: 'none', cursor: 'not-allowed'} : {}}
          className={styles.deleteModalButton}
          disabled={deletingArticle}
        >
          {deletingArticle ? <Spin indicator={antIcon} /> : null}
          {t('delete-article')}
        </Button>
      </div>
    </Modal>
  );
});

export default DeleteModal;
